module.exports = "#version 300 es\r\nprecision highp float;\r\n\r\nin vec2 fs_UV;\r\nout vec4 out_Col;\r\n\r\nuniform sampler2D u_frame;\r\nuniform float u_Time;\r\nuniform float u_Radius;\r\nuniform float u_Width;\r\nuniform float u_Height;\r\n\r\n// Interpolation between color and greyscale over time on left half of screen\r\nvoid main() {\r\n\tvec3 color = texture(u_frame, fs_UV).xyz;\r\n    float brightness = dot(color, vec3(0.2126, 0.7152, 0.0722));\r\n    if(brightness > u_Radius)\r\n    out_Col = vec4(color, 1.0);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/extractbright-frag.glsl
// module id = 41
// module chunks = 0